import { useEffect } from "react"
export default function () {
    useEffect(() => {
        window.location.pathname = '/permission_user'
    } ,[])
    return <div></div>
}